import type React from "react";
import { type PropsWithChildren } from "react";
import {
  Card,
  CardAction,
  CardContent,
  CardHeader,
  CardTitle,
} from "~/atoms/card";
import { cn } from "~/lib/utils";

interface Props extends PropsWithChildren {
  title: string;
  button?: React.ReactNode;
  className?: string;
}

export const DashboardCard = ({
  title,
  children,
  button,
  className,
}: Props) => (
  <Card size="sm" className={cn("max-h-120", className)}>
    <CardHeader>
      <CardTitle>{title}</CardTitle>
      {button && <CardAction>{button}</CardAction>}
    </CardHeader>
    <CardContent className="overflow-auto">{children}</CardContent>
  </Card>
);
